import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/layer3.svg")